import { render } from "./overview.vue?vue&type=template&id=97ad2594&scoped=true"
import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"

import "./overview.vue?vue&type=style&index=0&id=97ad2594&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ad2594"],['__file',"pages/EndataAuth/Account/App/components/profile/apiClients/overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97ad2594"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97ad2594', __exports__)) {
    api.reload('97ad2594', __exports__)
  }
  
  module.hot.accept("./overview.vue?vue&type=template&id=97ad2594&scoped=true", () => {
    api.rerender('97ad2594', render)
  })

}


export default __exports__